export default class GtmUserFeeds {
  static init(){
    this.bindCommentButtonClick();
    this.bindFacebookShareButtonClick();
    this.bindTwitterShareButtonClick();
    this.bindEmbedShareButtonClick();
  }

  static inViewPort(element) {
    if (!element || (element.nodeType !== 1)) { return false; }
    var rect = element.getBoundingClientRect();
    var height = document.documentElement.clientHeight;

    return (!!rect && rect.bottom >= 0 && rect.top <= height);
  }

  static bindCommentButtonClick() {
    $(".feeds-action__button-comment").click(function() {
      GtmUserFeeds.pushWithVideo('click', this.getAttribute('data-video-id'), 'following', 'comment');
    });
  }

  static bindFacebookShareButtonClick() {
    $(".popup-embed__share-facebook[data-source='feeds']").click(function() {
      GtmUserFeeds.pushWithType('click', 'vod.'+this.getAttribute('data-video-id'), 'share', 'following/facebook');
    });
  }

  static bindTwitterShareButtonClick() {
    $(".popup-embed__share-twitter[data-source='feeds']").click(function() {
      GtmUserFeeds.pushWithType('click', 'vod.'+this.getAttribute('data-video-id'), 'share', 'following/twitter');
    });
  }

  static bindEmbedShareButtonClick() {
    $(".popup-embed__tab #embed-tab[data-source='feeds']").click(function() {
      GtmUserFeeds.pushWithType('click', 'vod.'+this.getAttribute('data-video-id'), 'share', 'following/embed');
    });
  }

  static pushWithVideo(event,videoId,featureName,featureLocation) {
    window.dataLayer.push({
      event: event,
      video_id: videoId,
      feature_name: featureName,
      feature_location: featureLocation,
    });
  }

  static pushWithType(event,videoId,featureName,featureLocation) {
    window.dataLayer.push({
      event: event,
      feature_name: featureName,
      feature_location: featureLocation,
      feature_type: videoId
    });
  }
}
